var map = {
	"./air-conditioner/planner-element.tsx": 7245,
	"./armchairs/planner-element.tsx": 2295,
	"./balcony/planner-element.tsx": 7808,
	"./bench/planner-element.tsx": 5898,
	"./blackboard/planner-element.tsx": 5649,
	"./bookcase/planner-element.tsx": 5449,
	"./camera/planner-element.tsx": 2187,
	"./canteen-table/planner-element.tsx": 3957,
	"./canteencart/planner-element.tsx": 3380,
	"./chair/planner-element.tsx": 831,
	"./chairdesk/planner-element.tsx": 3508,
	"./child-chair-desk/planner-element.tsx": 9458,
	"./cleaningcart/planner-element.tsx": 7845,
	"./coat-hook/planner-element.tsx": 1839,
	"./column-square/planner-element.tsx": 6750,
	"./column/planner-element.tsx": 4168,
	"./cube/planner-element.tsx": 8125,
	"./desk/planner-element.tsx": 8645,
	"./deskdouble/planner-element.tsx": 9574,
	"./deskoffice/planner-element.tsx": 3685,
	"./electrical-panel/planner-element.tsx": 3101,
	"./fire-extinguisher/planner-element.tsx": 2652,
	"./fridge/planner-element.tsx": 1889,
	"./hanger/planner-element.tsx": 7591,
	"./hiroos/planner-element.tsx": 3472,
	"./hub/planner-element.tsx": 9737,
	"./image/planner-element.tsx": 8246,
	"./kitchen/planner-element.tsx": 2600,
	"./lim/planner-element.tsx": 2482,
	"./metal-detector/planner-element.tsx": 5034,
	"./monitor-pc/planner-element.tsx": 9326,
	"./naspo/planner-element.tsx": 9457,
	"./projector/planner-element.tsx": 7492,
	"./radiator-modern-style/planner-element.tsx": 6862,
	"./radiator-old-style/planner-element.tsx": 6492,
	"./recycling-bins/planner-element.tsx": 6863,
	"./router-wifi/planner-element.tsx": 555,
	"./schneider/planner-element.tsx": 2504,
	"./school-desk-double/planner-element.tsx": 4414,
	"./school-desk/planner-element.tsx": 5142,
	"./simple-stair/planner-element.tsx": 3516,
	"./sink/planner-element.tsx": 4471,
	"./smoke-detector/planner-element.tsx": 7956,
	"./sofa-single/planner-element.tsx": 4478,
	"./sofa/planner-element.tsx": 9363,
	"./table/planner-element.tsx": 24,
	"./teaching-post/planner-element.tsx": 6068,
	"./text-3d/planner-element.tsx": 2474,
	"./three-phase-panel/planner-element.tsx": 4447,
	"./toilet/planner-element.tsx": 5597,
	"./trash/planner-element.tsx": 4254,
	"./tv/planner-element.tsx": 7800,
	"./umbrella-stand/planner-element.tsx": 8525,
	"./wardrobe/planner-element.tsx": 3998
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8266;